<template>
	<el-tabs type="border-card">
		<el-tab-pane label="会员权益设置">
			<el-row :gutter="24" style="min-width:500px">
				<h3 style="padding-left: 10px;">
					<div class="flex">
						<div>
							会员权益列表
						</div>
						<div style="padding-left: 80%; float: right;margin-top: -15px;">
							<el-button type="primary" style="margin:10px" @click="editMember()">添加会员权益</el-button>
						</div>
					</div>
				</h3>
				<el-tabs style="padding-left: 10px;">
					<el-tab-pane label="显示">
						<el-table :data="tableData"
							:header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }"
							:cell-style="{'text-align': 'center'}">
							<el-table-column prop="id" label="ID" width="80px" align="center"></el-table-column>
							<el-table-column prop="name" label="名称" align="center"></el-table-column>
							<el-table-column prop="onlyBuy" label="是否单独购买" align="center">
								<template slot-scope="scope">
									{{scope.row.onlyBuy == 0?"不能单独购买":"能单独购买"}}
								</template>
							</el-table-column>
							<el-table-column prop="coupon" label="套餐类型" width="80px" align="center">
								<template slot-scope="scope">
									{{scope.row.combine}}
								</template>
							</el-table-column>
							<el-table-column prop="member" label="可见状态" align="center">
								<template slot-scope="scope">
									{{scope.row.member==0?'全部可见':scope.row.member==1?'仅老用户可见':scope.row.member==2?'仅新用户可见':'/'}}
								</template>
							</el-table-column>
							<el-table-column prop="couponId" label="券ID/券包ID" align="center">
								<template slot-scope="scope">
									{{scope.row.coupon == 0?"券ID:":"券包ID:"}}{{scope.row.couponId}}
								</template>
							</el-table-column>
							<el-table-column prop="priceMember" label="会员购买价格" align="center">
								<template slot-scope="scope">
									{{(scope.row.priceMember/100).toFixed(2)}}
								</template>
							</el-table-column>
							<el-table-column prop="priceNormal" label="非会员购买价格" align="center">
								<template slot-scope="scope">
									{{(scope.row.priceNormal/100).toFixed(2)}}
								</template>
							</el-table-column>
							<el-table-column label="业绩" align="center">
								<template slot-scope="scope">
									{{scope.row.commission?(scope.row.commission/100).toFixed(2):"暂未填写"}}
								</template>
							</el-table-column>
							<el-table-column label="跳转类型">
								<template slot-scope="{row}">
									{{row.jumpMode | jump}}
								</template>
							</el-table-column>
							<el-table-column prop="imageSmall" label="小图" align="center">
								<template slot-scope="scope">
									<el-image :src="scope.row.imageSmall"
										@click="openBig(scope.row.imageSmall)"></el-image>
								</template>
							</el-table-column>
							<!-- 							<el-table-column label="是否隐藏">
								<template slot-scope="scope">
									{{scope.row.hidden==1?'隐藏':'显示'}}
								</template>
							</el-table-column> -->
							<el-table-column prop="orderBy" label="排序" align="center">
								<template slot-scope="scope">
									第{{scope.row.orderBy}}张
								</template>
							</el-table-column>
							<el-table-column width="180" label="操作">
								<template slot-scope="scope">
									<el-button type="text" @click="deit(scope.row.id)">编辑</el-button>
									<el-button type="text" v-if="scope.row.businessType==0"
										@click="hiddenordel(scope.row.id,4,scope.row.isHidden)"><span
											v-if="scope.row.isHidden==0">隐藏</span><span
											v-if="scope.row.isHidden==1">显示</span>
									</el-button>
									<el-button type="text" v-if="scope.row.businessType==1"
										@click="hiddenordel(scope.row.id,3)"><span
											style="color: red;">删除</span></el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
					<el-tab-pane label="隐藏">
						<el-table :data="tableData2"
							:header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }"
							:cell-style="{'text-align': 'center'}">
							<el-table-column prop="id" label="ID" width="80px" align="center"></el-table-column>
							<el-table-column prop="name" label="名称" align="center"></el-table-column>
							<el-table-column prop="onlyBuy" label="是否单独购买" align="center">
								<template slot-scope="scope">
									{{scope.row.onlyBuy == 0?"不能单独购买":"能单独购买"}}
								</template>
							</el-table-column>
							<el-table-column prop="coupon" label="套餐类型" width="80px" align="center">
								<template slot-scope="scope">
									{{scope.row.combine}}
								</template>
							</el-table-column>
							<el-table-column prop="member" label="可见状态" align="center">
								<template slot-scope="scope">
									{{scope.row.member==0?'全部可见':scope.row.member==1?'仅老用户可见':scope.row.member==2?'仅新用户可见':'/'}}
								</template>
							</el-table-column>
							<el-table-column prop="couponId" label="券ID/券包ID" align="center">
								<template slot-scope="scope">
									{{scope.row.coupon == 0?"券ID:":"券包ID:"}}{{scope.row.couponId}}
								</template>
							</el-table-column>
							<el-table-column prop="priceMember" label="会员购买价格" align="center">
								<template slot-scope="scope">
									{{(scope.row.priceMember/100).toFixed(2)}}
								</template>
							</el-table-column>
							<el-table-column prop="priceNormal" label="非会员购买价格" align="center">
								<template slot-scope="scope">
									{{(scope.row.priceNormal/100).toFixed(2)}}
								</template>
							</el-table-column>
							<el-table-column label="业绩" align="center">
								<template slot-scope="scope">
									{{scope.row.commission?(scope.row.commission/100).toFixed(2):"暂未填写"}}
								</template>
							</el-table-column>
							<el-table-column label="跳转类型">
								<template slot-scope="{row}">
									{{row.jumpMode | jump}}
								</template>
							</el-table-column>
							<el-table-column prop="imageSmall" label="小图" align="center">
								<template slot-scope="scope">
									<el-image :src="scope.row.imageSmall"
										@click="openBig(scope.row.imageSmall)"></el-image>
								</template>
							</el-table-column>
							<!-- 							<el-table-column label="是否隐藏">
								<template slot-scope="scope">
									{{scope.row.hidden==1?'隐藏':'显示'}}
								</template>
							</el-table-column> -->
							<el-table-column prop="orderBy" label="排序" align="center">
								<template slot-scope="scope">
									第{{scope.row.orderBy}}张
								</template>
							</el-table-column>
							<el-table-column width="180" label="操作">
								<template slot-scope="scope">
									<el-button type="text" @click="deit(scope.row.id)">编辑</el-button>
									<el-button type="text" v-if="scope.row.businessType==0"
										@click="hiddenordel(scope.row.id,4,scope.row.isHidden)"><span
											v-if="scope.row.isHidden==0">隐藏</span><span
											v-if="scope.row.isHidden==1">显示</span>
									</el-button>
									<el-button type="text" v-if="scope.row.businessType==1"
										@click="hiddenordel(scope.row.id,3)"><span
											style="color: red;">删除</span></el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
				</el-tabs>
			</el-row>
		</el-tab-pane>
		<el-tab-pane label="首页轮播图">
			<el-row :gutter="24" style="min-width:1500px">
				<el-col :span="8">
					<h3>首页效果</h3>
					<el-carousel height="310px" style="width:410px; background-color:#ddd">
						<el-carousel-item v-for="item in banners" :key="item.url">
							<el-image :src="item.image"></el-image>
						</el-carousel-item>
					</el-carousel>
				</el-col>
				<el-col :span="16" style="border-left: 2px solid #bbb">
					<div style="border-bottom: 1px solid #bbb;">
						<h3>轮播图列表</h3>
						<el-button style="margin:10px" @click="editInit()">添加轮播图</el-button>
					</div>
					<div v-for="(item, index) in banners" :key="item.url" style="width:800px;">
						<el-row :gutter="24" style="border-bottom: 1px solid #bbb;">
							<el-col :span="8">
								<el-image :src="item.image" style="width:300px; height:211px; margin:10px"></el-image>
							</el-col>
							<el-col :span="16">
								<div style="margin: 20px 40px;">
									<el-button type="primary" size="small" @click="move(item.id, 1)"
										style="margin: 0px 5px" v-if="index!=0">上移</el-button>
									<el-button type="primary" size="small" @click="move(item.id, 2)"
										style="margin: 0px 5px" v-if="index!=banners.length-1">下移</el-button>
									<el-button @click="editInit(item)" size="small" style="margin: 0px 5px">编辑
									</el-button>
									<!-- <el-popconfirm title="确认删除该轮播图？" @onConfirm="delBanner(item.id)">
										
									</el-popconfirm> -->
									<el-button type="danger" slot="reference" size="small" @click="open(item.id)">删除
									</el-button>
								</div>
							</el-col>
						</el-row>
					</div>
				</el-col>
			</el-row>
		</el-tab-pane>
		<el-dialog :visible.sync="uploadImage" width="50%">
			<div>
				<h2>轮播图详情</h2>
				<div class="upload_style">
					图片：
					<upload class="el-tabs-pane-upload" ref="sss" style="width:300px; height:211px; margin-left:100px;"
						v-model="banner.image" />
				</div>
				<div class="upload_style">
					跳转方式：
					<el-radio v-for="mode in modes" :key="mode.value" :label="mode.value" v-model="banner.jumpMode">
						{{ mode.label }}</el-radio>
				</div>
				<div class="upload_style" v-if="banner.jumpMode!=4">
					跳转地址：
					<el-input style="width:300px" v-model="banner.url" :disabled="banner.jumpMode==0"></el-input>
				</div>
				<div class="upload_style" v-else>
					小程序appid：
					<el-input style="width:300px" v-model="banner.url"></el-input>
				</div>
				<el-button type="primary" style="margin-left:80%; margin-top:20px;" @click="edit()">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="bigimg" width="50%" height="50%" custom-class="">
			<el-image :src="bigimgUrl" style="width: 100%;height: 100%;"></el-image>
		</el-dialog>
	</el-tabs>
</template>

<script>
	import wxlogin from "vue-wxlogin";
	import upload from "../../compents/upload/upload";
	export default {
		components: {
			wxlogin,
			upload
		},
		data() {
			return {
				query: {
					hidden: ''
				},
				setting: {
					title: undefined,
					bossName: undefined,
					time: undefined,
					noticeData: undefined,
					remark: "",
				},
				qrCodeWindow: false,
				uploadImage: false,
				memberDetail: false,
				data: [],
				tableData: [],
				tableData2: [],
				image: undefined,
				qrcodeData: {
					appid: "wxcf9c5274400f0691",
					scope: "snsapi_userinfo",
					redirect_uri: "http://admin.ciaojian.com%2Fwechat%2FgetCode",
					state: "STATE#wechat_redirect",
				},
				banner: {},
				banners: [],
				modes: [{
					label: "不跳转",
					value: 0,
				}, {
					label: "微信推文",
					value: 1,
				}, {
					label: "tapbar页面",
					value: 2,
				}, {
					label: "新的页面",
					value: 3,
				}, {
					label: "微信小程序",
					value: 4,
				}],
				bigimg: false,
				bigimgUrl: ''
			}
		},
		filters: {
			jump(val) {
				if (val == 0) {
					return '没有跳转'
				}
				if (val == 1) {
					return '外部链接'
				}
				if (val == 2) {
					return '填写手机号'
				}
				if (val == 3) {
					return '填写收货地址'
				}
			}
		},
		mounted() {
			this.bannerList();
			this.getTableData();
		},
		methods: {
			move(id, direct) {
				this.$http.post("DNotice/move/" + id + "/" + direct).then(res => {
					if (res.body.code == 200) {
						this.$message.success("移动成功")
						this.bannerList();
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			editInit(item) {
				this.uploadImage = true;
				if (item) {
					this.banner = JSON.parse(JSON.stringify(item));
				} else {
					this.banner = {
						id: undefined,
						image: undefined,
						url: undefined,
						jumpMode: 0,
					};
				}
			},
			edit() {
				if (!this.banner.image) return this.$message.error("请选择图片！")
				this.$http.post("DNotice/editBanner", JSON.stringify(this.banner)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存/编辑成功")
						this.uploadImage = false;
						this.bannerList();
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			open(id) {
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post("DNotice/delBanner/" + id).then(res => {
						if (res.body.code == 200) {
							this.$message.success("删除成功!")
							this.bannerList();
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			bannerList() {
				this.$http.get("DNotice/bannerList").then(res => {
					this.banners = res.body.data
				})
			},
			editMember() {
				this.$router.push({
					path: "/memberDetailSetting"
				})
			},
			getTableData() {
				this.$http.get("member/detail?text=显示").then(res => {
					this.tableData = res.body.data;
				})
				this.$http.get("member/detail?text=隐藏").then(res => {
					this.tableData2 = res.body.data;
				})
			},
			deit(id) {
				this.$router.push({
					path: 'memberDetailSetting',
					query: {
						id: id
					}
				})
			},
			openBig(url) {
				this.bigimg = true
				this.bigimgUrl = url
			}
		},
	}
</script>

<style lang="less" scoped>
	.upload_style {
		margin: 10px 0px;
		font-size: 16px;
		font-weight: 600;
	}

	.flex {
		display: flex;
	}
</style>